<template>
    <views>
        <div style="background-color:rgba(255, 255, 255, 0.4);margin-bottom:1rem;border-radius:0.3rem">
            <drawer v-if="value.type === 1" v-model="value" @ok="ok"></drawer>
        </div>
        <views v-if="value.type === 2" class="input-info-list">
            <input v-model="value.value" type="text" :placeholder="value.tip">
        </views>
        <views v-if="value.type === 4" class="title">{{ value.name }}</views>
    </views>
</template>
<script>
import Drawer from '@/components/drawer'
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        Drawer
    },
    methods: {
        ok(val) {
            console.log(val)
            this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import './index.scss';
</style>
